// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/lib/angular-neat-panel/angular-neat-layout.css
// module id = 331
// module chunks = 0